import { More } from "@mui/icons-material";
import { List, ListItem, Tooltip, Typography, TypographyProps } from "@mui/material";
import { Box } from "@mui/system";
import { isEmpty } from "lodash";
import React, { useMemo, useState } from "react";
import CommonPopper from "../commonPopper";
import "./index.css";

interface TruncatedScrollingTextProps {
  name: string;
  maxLength?: number; // Length till which the text should be truncated
  typographyVariant?: TypographyProps["variant"]; // Material UI Typography variant
  onClick?: TypographyProps["onClick"]
  sx?: TypographyProps["sx"]
  color?: TypographyProps["color"]
  labelSX?: TypographyProps["sx"]
  labels?: { [key: string]: string };
}

const TruncatedScrollingText: React.FC<TruncatedScrollingTextProps> = ({
  name,
  maxLength = 15,
  typographyVariant = "body1",
  onClick = () => { },
  color = "inherit",
  sx = {},
  labelSX = {},
  labels = {}
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const truncatedName = useMemo(
    () =>
      name?.length > maxLength
        ? name?.substring(0, maxLength) + "..."
        : name,
    [name, maxLength]
  );

  return (
    <Box sx={{ display: "flex", justifyContent: "start" }}>
      <Tooltip title={name}>
        <Box
          className="truncated-container"
        // onMouseEnter={() => name?.length > maxLength && setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
        >
          <Typography
            variant={typographyVariant}
            className={`${name?.length > maxLength ? "truncated-text" : ""} 
            
            `}
            onClick={onClick}
            color={color}
            sx={{ ...sx }}
          >
            {truncatedName}

          </Typography>

        </Box>
      </Tooltip>
      {!isEmpty(labels) && <CommonPopper
        elevatePopper
        title="Labels"
        trigger={<Tooltip title="Labels">
          <More fontSize="inherit" className="hand" sx={{ ml: 1, ...labelSX }} color="inherit" />
        </Tooltip>}
        child={
          <List sx={{ "min-width": "20em" }}>
            {Object.keys(labels)?.map((key) => <ListItem sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">{key}</Typography>
              <Typography sx={{ textAlign: "right" }}>{labels[key]}</Typography>
            </ListItem>)}
          </List>
        } />}

    </Box>
  );
};

export default TruncatedScrollingText;
